'use strict';

const { Future } = require('posterus');
const Promise = require('promise');

exports.after = after;
function after(time, error, result) {
  return Future.init(future => timeout(time, future.settle.bind(future), error, result));
}

exports.timeout = timeout;
function timeout(time, fun, ...args) {
  return clearTimeout.bind(null, setTimeout(fun, time, ...args));
}

// Workaround for the broken implementation of async import in Webpack. By
// default, Webpack returns a SUCCESSFUL promise after the first failed import,
// starting with the second attempt.
exports.asyncImport = asyncImport;
function asyncImport(fun) {
  if (typeof fun !== 'function') {
    throw TypeError(`Expected a function, got: ${fun}`);
  }
  let result;
  return function asyncImportOnce() {
    if (!result) result = Promise.resolve().then(fun);
    return result;
  };
}



// WEBPACK FOOTER //
// ./src/shared/utils.js